import React, {useState} from 'react'
import style from './index.module.scss'
import PropTypes from 'prop-types'
import { Label } from '../Label'
import { DropDown } from '../DropDown'
import { TooltipError } from '../TooltipError'
export const Period = (props) => {
    
    const handleTextChange = (value) => {
        props.onChangeText(value.target.value.replace(/\D/g, ""))
    }
    const droplist = [
        {id:1, label:'meses'},
        {id:12, label:'anos'},
    ]
    function getDefaultValue(){
        return droplist.find(e => e.id === parseInt(props.valueSelect))
    }
    return (
        <div className={style.main}>
            <Label>{props.label}</Label>
            <div className={style.valueInput}>
                <input
                    className={style.textinput} 
                    onChange={handleTextChange}
                    value={props.valueText}
                    type="tel"
                    />
                <div className={style.dropDown}>
                    <DropDown 
                        list={droplist}
                        selected={getDefaultValue()}
                        onChange={props.onChangeSelect}
                    />
                </div>
            </div>
            {(props.valid)?
                null
            :<TooltipError text="Preencha esse campo"/>}
        </div>
    )
}
Period.propTypes = {
    valueText: PropTypes.any,
    onChangeText: PropTypes.func
}